import { message } from "antd";
import { useCallback } from "react";
import { useFullScreenHandle } from "react-full-screen";

export const useFullScreen = () => {
  const handle = useFullScreenHandle();

  const onClickFullScreen = useCallback(() => {
    try {
      handle.enter();
    } catch (error) {
      message.warning({
        content: "Fullscreen feature not supported in ios mobile devices",
      });
    }
  }, [handle]);

  return {
    onClickFullScreen,
    handle,
  };
};
